import { ApiService } from "../api";
import { ProjectBudget } from "../projects";

/**
 * Functions for budget related information.
 */
export class ProjectBudgetService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async findById(budgetId: number): Promise<ProjectBudget> {
		const budgetData = await this.apiService.get(
			`/api/v1/project-budget/${budgetId}`,
		);
		const budget = await budgetData.json();
		return ProjectBudget.fromJson(budget);
	}

	public async findBudgetsForAccount(
		accountId: string,
	): Promise<ProjectBudget[]> {
		const budgetData = await this.apiService.get(
			`/api/v1/accounts/${accountId}/project-budgets`,
		);
		const budgets = await budgetData.json();

		return ProjectBudget.fromJsonArray(budgets);
	}

	public async create(projectBudget: ProjectBudget): Promise<ProjectBudget> {
		const budgetData = await this.apiService.post(
			`/api/v1/accounts/${projectBudget.accountId}/project-budgets`,
			projectBudget,
		);
		const budget = await budgetData.json();
		return ProjectBudget.fromJson(budget);
	}

	public async save(projectBudget: ProjectBudget): Promise<ProjectBudget> {
		const budgetData = await this.apiService.post(
			`/api/v1/project-budget/${projectBudget.id}`,
			projectBudget,
		);
		const budget = await budgetData.json();
		return ProjectBudget.fromJson(budget);
	}
}
